module.exports = __webpack_public_path__ + "img/medical.d4ef20f6.svg";